import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../auth.service';
import { BehaviorSubject } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'check-user',
  templateUrl: './check-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckUserComponent implements OnInit {

  private userDetails_: BehaviorSubject<any[]> = new BehaviorSubject(undefined);
  public userDetails = this.userDetails_.asObservable();
  public userDetailsForm = new FormGroup({});

  private busy_ = new BehaviorSubject(false);
  public busy = this.busy_.asObservable();

  private errorMessage_ = new BehaviorSubject('');
  public errorMessage = this.errorMessage_.asObservable();

  constructor(private auth: AuthService) { 
  }

  ngOnInit() { 
    this.postUserDetails();
  }

  public async postUserDetails() {
    this.busy_.next(true);
    this.errorMessage_.next('');

    const userDetails = await this.auth.getUserDetails();

    const preferred_username = userDetails.find((attribute) => {
      if(attribute.getName() === 'preferred_username'){
        return true;
      }
    })

    var user = {accessToken: await this.auth.getAccessToken(), userName: preferred_username.getValue()};

    try {
      window.parent.postMessage(user, '*');
    } catch(er) {
      console.log("window.parent.postMessage" + er);
    }
    
    try {
      top.postMessage(user, '*');
    } catch(er) {
      console.log("top " + er);
    }

    try {
      parent.postMessage(user, '*');
    } catch(er) {
      console.log("parent " + er);
    }

    this.errorMessage_.next('User details posted');
  }
}
